// extracted by mini-css-extract-plugin
export default {"modalOverlay":"TM-z","modalContent":"UM-z","header":"VM-z","close":"WM-z"};